/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LiveBiddingMetricsDto } from '../../models/live-bidding-metrics-dto';

export interface GetLiveBiddingMetrics$Params {
  fromDate?: string;
  toDate?: string;
  'X-API-Version'?: string;
}

export function getLiveBiddingMetrics(http: HttpClient, rootUrl: string, params?: GetLiveBiddingMetrics$Params, context?: HttpContext): Observable<StrictHttpResponse<LiveBiddingMetricsDto>> {
  const rb = new RequestBuilder(rootUrl, getLiveBiddingMetrics.PATH, 'get');
  if (params) {
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LiveBiddingMetricsDto>;
    })
  );
}

getLiveBiddingMetrics.PATH = '/api/metrics/live-bidding';
